<template>
  <div class="coming-soon">
    <v-app-bar color="primary" dark>
      <se-button variant="text" @click="$router.go(-1)" style="min-width: 48px; height: 48px; border-radius: 50%;">
        <v-icon>mdi-arrow-left</v-icon>
      </se-button>
      <v-toolbar-title>{{ title }} - IS 800:2007</v-toolbar-title>
    </v-app-bar>

    <v-main>
      <v-container>
        <v-row justify="center" align="center" style="height: 60vh;">
          <v-col cols="12" md="6" class="text-center">
            <v-icon size="120" color="primary" class="mb-6">mdi-construction</v-icon>
            <h1 class="text-h3 mb-4">Coming Soon</h1>
            <p class="text-h6 text-medium-emphasis mb-6">
              {{ description }} module is under development and will be available soon.
            </p>
            <se-button variant="secondary" @click="$router.go(-1)">
              <v-icon start>mdi-arrow-left</v-icon>
              Go Back
            </se-button>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script setup lang="ts">
import SeButton from '@/components/SEButton.vue'

interface Props {
  title: string
  description: string
}

const _props = defineProps<Props>()
</script>

<style scoped>
.coming-soon {
  height: 100vh;
}
</style>
